/**
 * Pure helpers for IOSInstallModal. Kept separate from the JSX so the
 * analytics contract is unit-testable without spinning up a React renderer
 * (the monorepo has a dual-React-copy issue with jsdom + RTL).
 */

export const EVENT_OPENED = 'pwa_ios_modal_opened';
export const EVENT_CLOSED = 'pwa_ios_modal_closed';

/**
 * Fire the "opened" PostHog event. Accepts an injected capture fn so tests
 * can drive it with a spy and so the component does not have to import the
 * analytics module from within JSX.
 */
export function fireOpened(captureFn) {
  if (typeof captureFn !== 'function') return;
  captureFn(EVENT_OPENED, {});
}

export function fireClosed(captureFn) {
  if (typeof captureFn !== 'function') return;
  captureFn(EVENT_CLOSED, {});
}
